module.exports = __webpack_public_path__ + "static/media/beep.871ccab1.mp3";